<template>
    <div class="content">
        <div class="content1">
            <div class="top" v-for="(item,index) in list" :key="index" v-on:mouseover="handleOver1($event,item,index)" v-on:mouseout="handleOut1($event,item,index)">
                <div class="top-img" v-if="item.flag">
                    <div class="top-img1">
                        <div>
                            {{$fnc.get_int_dec(item.money,'int')}}
                        </div>
                        <div>
                            <ul>
                                <li>
                                    全场满{{item.cdn_xfm}}可用
                                </li>
                                <li>
                                    特价商品除外
                                </li>
                                <li>
                                    立即兑换>>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="top1" v-else>
                </div>
                <div class="top-div2">
                    全场满{{item.cdn_xfm}}减{{$fnc.get_int_dec(item.money,'int')}}元优惠券
                </div>
                <div class="top-div3">
                    {{item.jf_change}}积分
                </div>
                <!-- <span class="jia"></span> -->
                <!-- <div class="top-div4">
                    市场价 ￥40
                </div> -->
            </div>
        </div>
        <div class="content2">
            <div class="cont" v-for="(items,index1) in dataList" :key="index1">
                <div class="cont-img" v-on:mouseover="handleOver($event,items,index1)" v-on:mouseout="handleOut($event,items,index1)">
                    <img :src="items.piclink" v-if="items.flag"/>
                    <img src="../../assets/img1/sy/sm.png" v-else/>
                </div>
                <div>
                    {{items.title}}
                </div>
                <div>
                    {{items.score_rob}}积分
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { $ } from '_dom7@4.0.4@dom7';
export default {
    data(){
        return{
            //二维码图层
            // flag:true,
            list:[],
            dataList:[],
            cateId: "",
            page: {
                num: 1, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
                size: 10 //每页数据条数,默认10
            },
            search_title: "",
            coupon:[],
        }
    },
    mounted(){
        this.jifen_coupon();
        this.integral_cate_lists_all();
        this.redeem_lists();
    },
    methods:{
        //鼠标的移入移出
        handleOver (e,items,index) {
            items.flag=false;
            this.$set(this.dataList,index,items)
		},
		handleOut (e,items,index) {
            items.flag=true;
            this.$set(this.dataList,index,items)
		},
         handleOver1 (e,item,index) {
            item.flag=false;
            this.$set(this.list,index,item)
		},
		handleOut1 (e,item,index) {
            item.flag=true;
            this.$set(this.list,index,item)
		},
        //接口调用优惠券
       jifen_coupon() {
            this.$api.getCoupon.jifen_coupon({}).then(res => {
                if (res.code == 200) {
                    this.list = res.result;
                    this.list.forEach(item => {
                        item.flag = true
                    });
                    console.log(this.list)
                }
            });
        },
        //积分
        integral_cate_lists_all() {
            var params = {};
            this.$api.getCoupon.integral_cate_lists_all({}).then(res => {
                if (res.code == 200) {
                    this.cateList = res.result;
                    if (this.cateList && this.cateList[0]) {
                        this.cateId = this.cateList[0].id;
                    }
                }
            });
        },
        redeem_lists(id) {
            var params = {};
            params.page = this.page.num;
            params.title = this.search_title || "";
            params.cate = this.cateId;
            this.$api.getCoupon.redeem_lists(params).then(res => {
                if(res.code == 200){
                this.dataList = [];
                var arr = res.result.redeem;
                // 如果是第一页需手动置空列表
                if (this.page.num == 1) this.dataList = [];
                // 把请求到的数据添加到列表
                    this.dataList = this.dataList.concat(arr);
                    arr.forEach(item => {
                        item.flag = true
                    });
                }
            });
        },
    }
}
</script>
 
<style scoped>
/* @import url('../../assets/css/car.css'); */
.content{
    /* border:1px solid red; */
    width: 100%;
    background-color: #f2f2f2;
    margin-top: 20px;
    margin-bottom: 20px;
}
.content1{
    /* border: 1px solid red; */
    width: 1200px;
    margin: auto;
    padding-bottom: 50px;
}
.top{
    display: inline-block;
    /* border: 1px solid red; */
    width: 250px;
    height: 250px;
    margin-left: 23px;
    margin-right: 23px;
    margin-top: 40px;
    margin-bottom: 70px;
}
.top1{
    display: inline-block;
    width: 250px;
    height: 250px;
    margin-right: 23px;
    background: url(../../assets/img1/sy/sm.png) no-repeat;
    background-size: 250px;
}
.top-img{
    /* border: 1px solid red; */
    display: inline-block;
    width: 250px;
    height: 250px;
    position: relative;
    background: url(../../assets/img1/jfsc/youhuijuan.jpg) no-repeat;
    background-size: 250px 250px;
}
.top-img1{
    /* border: 1px solid blue; */
    width: 220px;
    height: 80px;
    position: absolute;
    top: 95px;
    left: 15px;
    display: flex;
}
.top-img1>div:nth-child(1){
    border-right: 0.1px solid white;
    width: 60px;
    height: 45px;
    font-size: 50px;
    color: white;
    text-align: right;
    padding-right: 10px;
    padding-top: 25px;
    background: url(../../assets/img1/jfsc/qianfuhao.png) no-repeat;
    background-size: 20px;
    background-position: 50px 36px;
}
.top-img1>div:nth-child(2){
    color: white;
    flex: 1;
    /* border: 1px solid white; */
    text-align: center;
}
.top-img1>div:nth-child(2)>ul>li:nth-child(1){
    font-size: 18px;
}
.top-img1>div:nth-child(2)>ul>li:nth-child(2){
    font-size: 14px;
    margin-top: 8px;
    margin-bottom: 8px;
}
.top-img1>div:nth-child(2)>ul>li:nth-child(3){
    border: 1px solid white;
    width: 90px;
    height: 18px;
    margin-top: 10px;
    border-radius: 10px;
    margin: auto;
    color: #bf0f7b;
    background-color: white;
}
.top-div2{
    color: black;
    font-size: 18px;
    margin-top: 20px;
    font-weight: bold;
}
.top-div3{
    /* display: inline-block; */
    color: #bf0f7b;
    font-size: 24px;
    margin-top: 13px;
    font-weight: bold;
    float: left;
}
.top-div4{
    /* display: inline-block; */
    font-size: 17px;
    color: black;
    margin-left: 10px;
    font-weight: bold;
    text-decoration: line-through;
    float: right;
    margin-top: 13px;
}
.content2{
    /* border: 1px solid red; */
    width: 1200px;
    margin: auto;
    overflow:hidden;
}
.cont{
    /* border: 1px solid red; */
    width: 250px;
    height:350px;
    /* display: inline-block; */
    float: left;
    margin-left: 23px;
    margin-right: 23px;
    margin-top: 20px;
}
.cont>div:nth-child(1){
    width: 250px;
    height: 250px;
}
.cont>div:nth-child(1)>img{
    /* border: 1px solid #bf0f7b; */
    cursor: pointer;
    width: 250px;
    height: 250px;
    
}
.cont-img>img:nth-child(2){
    display: none;
}
.cont>div:nth-child(2){
    font-size: 14px;
    font-weight: bold;
    color: black;
    margin-top: 12px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.cont>div:nth-child(3){
    font-size: 24px;
    font-weight: bold;
    color: #bf0f7b;
    margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/recharge/index1.vue